import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Status, UpdateStatus } from './status.interface';
import { catchError, map, throwError } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class StatusService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getStatusUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereStatus.getCerereStatuses;
    private getStatusDTUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereStatus.getCerereStatusesDT;
    private storeStatusURL =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereStatus.storeCerereStatus;

    private deleteStoreStatus =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereStatus.deleteCerereStatus;

    private updateStatusStore =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereStatus.putCerereStatus;

    private updateOrderUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereStatus.updateOrder;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereStatus.changeStatusCerereStatusActive;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.cerereStatus.changeStatusCerereStatusPublic;

    private getSolicitareRankURL = this.basePath + environment.interop.dgitl.nomenclatoare.cerereStatus.rankList;

    private clearCacheUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cerereStatus.clearCache;

    constructor(private http: HttpClient) { }

    getStatusDT() {
        return this.http.get(this.getStatusDTUrl, this.httpOptions);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    storeStatus(data: Status) {
        return this.http.post(this.storeStatusURL, data, this.httpOptions);
    }

    updateStatus(updateStatus: UpdateStatus) {
        return this.http.put(
            this.updateStatusStore,
            updateStatus,
            this.httpOptions
        );
    }

    deleteStatus(sectionId: number) {
        return this.http.delete(this.deleteStoreStatus + sectionId);
    }

    getStatuses() {
        return this.http
            .get<{ errors: boolean; data: any; status_code: number }>(
                this.getStatusUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item: any) => ({
                        id: item.id_cerere_status,
                        name: item.name,
                        slug: item.slug
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request statuses:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    updateOrder(id: number, data: any) {
        return this.http.put(this.updateOrderUrl + id, data, this.httpOptions);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getRanksList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getSolicitareRankURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                        slug: item.slug,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get ranks list:', error);
                    return throwError(error);
                })
            );
    }
}
